import React, { Component } from "react";
import { withRouter } from "react-router";

import swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

import moment from "moment";

import debounce from "lodash.debounce";

import axios from "../../axios-instance.js";

import Container from "../../components/UI/Container/Container.js";
import Icon from "../../components/UI/Icon/Icon.js";
import { Stepper } from "../../components/Stepper/Stepper.js";
import NewLoader from "../../components/NewLoader/NewLoader.js";
import CheckBox from "../../components/UI/Checkbox/CheckBox";

import { FillFields, ChoosePaymentMethod, SelectTickets } from "./Steps/index.js";
import TermsAndConditionsModal from "../SeasonPass/TermsAndConditionsModal/TermsAndConditionsModal.js";
import { bankLogos, fee, paymentMethodOptions, days, month, years } from "../SeasonPass/constants.js";
import { getCurrencieLabel } from "../../constants/currencies.js";
import { getTotal } from "../SeasonPass/helpers/index.js";
import { filterUnavailableTicketTemplates } from "../../helpers/filterUnavailableTicketTemplates.js";
import { showErrorModal } from "../../modals/index.js";

import PleaseWait from "../../images/please-wait-season-pass-modal.svg";

import "../SeasonPass/SeasonPass.sass";
import "./OpenSell.sass";
import { isValidEmail } from "../../helpers/validators.js";
import { getRegion } from "../../helpers/getRegion";
import { isNoSeatTicket, isSeatsIoTicket } from "../../helpers/ticketHelper.ts";
import { getPrice, getTotalFee, recalculatePrice } from "../../helpers/ticketPriceHelper.ts";
import { executePayment } from "../../helpers/paymentHelper/paymentHelper.ts";
import { paymentTypes } from "../../constants/paymentType.ts";
import { SeasonPassFieldLabel } from "../SeasonPass/SeasonPassFieldLabel.js";
import Select from "react-select";
import { getCustomURLs } from "../../helpers/getCustomURLs.js";
import { showErrorPaymentModal, showProcessingPaymentModal, showRefundPaymentModal, showSuccessPaymentModal } from "../../components/Sells/Modals/statusModals.js";
import { getCurrentLanguageTexts } from "../../constants/seasonPassPersonalInfoLangs.js";
import { OfferSteps } from "./Steps/OfferSteps.js";

const MySwal = withReactContent(swal);

export const mapSeatIo = ({
  category: { label, key },
  labels: { section, parent, own },
  pricing: { price },
  originalPrice,
  eventData,
}) => {
  const [area, side] = section.split("-");
  const ticketTemplate = eventData.ticketTemplates.find(
    ({ categoryKey }) => +categoryKey === +key
  );
  const ticketTemplateId = ticketTemplate && ticketTemplate.ticketTemplateId;

  if (!originalPrice) {
    originalPrice = price;
  }

  return {
    ticketTemplateId,
    ticketName: label,
    area: area,
    row: parent,
    seat: own,
    side: side,
    amount: price,
    fixedDiscount: +(+originalPrice - +price).toFixed(2),
  };
};

export const mapSeat = (seats, ticket, i, coupon) => {
  const { ticketTemplateId, count } = ticket;

  for (let j = 0; j < count; j++) {
    let fixedDiscount = 0;
    if (coupon && (!coupon.ticketTypeIds || coupon.ticketTypeIds.length === 0)) {
      fixedDiscount = coupon.fixedDiscount;
    }
    else if (coupon && coupon.ticketTypeIds && coupon.ticketTypeIds.filter((v) => (v === ticketTemplateId)).length > 0 && coupon.ticketTypeIds.filter((v) => (v === ticketTemplateId)).length <= count && j < coupon.ticketTypeIds.filter((v) => (v === ticketTemplateId)).length) {
      fixedDiscount = coupon.fixedDiscount;
    }

    if (!fixedDiscount) {
      fixedDiscount = 0;
    }

    if (!ticket.price) {
      ticket.price = 0;
    }

    if (!ticket.originalPrice) {
      ticket.originalPrice = ticket.price;
    }

    const seat = {
      ticketTemplateId: ticketTemplateId,
      discount: (i == 0 && j < 2 && coupon) ? coupon.discount : 0,
      fixedDiscount: +(fixedDiscount + +ticket.originalPrice - +ticket.price).toFixed(2),
    };

    seats.push(seat);
  }

  return seats;
};

class OpenSell extends Component {
  state = {
    fields: {
      fullName: "",
      physicalAddress: "",
      city: "",
      postalCode: "",
      phoneNumber: "",
      buyerEmail: "",
      birthday: null,
      gender: "",
      paymentMethod: null,
      companyName: "",
      companyVatNumber: "",
      buyerCountry: "",
    },
    checkboxeFields: {
      termsAndConditionsChecked: false,
    },
    tickets: [],
    transactionData: {
      orderId: "",
      paymentAmount: "",
      currencyCode: "RSD",
    },
    eventData: null,
    isOffers: false,
    step: 1,
    themeColor: "#F95700",
    hasSeats: undefined,
    feeRate: fee,
    fixedFeeRate: 0,
    loading: true,
    submittBlocked: false,
    reapetedBuyerEmail: "",
    coupon: null,
  };

  handleChangeStep = (nextStep) => {
    this.setState({ step: nextStep });
  };

  setOrderDataToState = (data) => {
    const fields = {
      ...this.state.fields,
      fullName: data.fullName,
      physicalAddress: data.physicalAddress,
      city: data.city,
      postalCode: data.postalCode,
      phoneNumber: data.phoneNumber,
      buyerEmail: data.buyerEmail,
      birthday: data.birthday && moment(data.birthday).year() >= 1935 ? data.birthday : null,
      gender: data.gender,
      companyName: data.companyName,
      companyVatNumber: data.companyVatNumber,
    };

    this.setState({
      fields,
    });
  };

  showSalesUnavailableModal = () => {
    const txt = getCurrentLanguageTexts();

    MySwal.fire({
      title: txt.sellPageModals["Sales not available"],
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  showPleaseWaitModal = () => {
    const txt = getCurrentLanguageTexts();

    MySwal.fire({
      imageUrl: PleaseWait,
      title: txt.sellPageModals["Please wait"],
      text: txt.sellPageModals["You will be redirected to the payment page"],
      allowEscapeKey: false,
      customClass: "seasonpass__modal partizan-info-modal",
      allowOutsideClick: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });
  };

  getTransactionData = async () => {
    const txt = getCurrentLanguageTexts();

    try {
      const id = !!this.props.match.params.id
        ? this.props.match.params.id
        : this.props.match.params.transactionId;

      const { data: transaction } = await axios.get(
        `Transaction/${id}`
      );
      if (transaction) {
        this.handleOrderStatuses(transaction);
        this.setOrderDataToState(transaction);
      }
    } catch (e) {
      showErrorModal({
        text: txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
      console.log(e);
    }
  };

  setPrice = () => {
    const { tickets, coupon, isOffers } = this.state;

    recalculatePrice(tickets);

    this.setTransactionData({
      paymentAmount: getPrice(tickets, coupon),
    });
  };

  paymentStatus = -1;
  handleOrderStatuses = (transaction) => {
    const { isOffers, eventData } = this.state;

    if (transaction.paymentStatus === 5 ||
      (transaction.paymentStatus === 0
        && !window.location.href.includes("offers"))) {
      setTimeout(() => {
        this.getTransactionData();
      }, 4000);
    }

    if (this.paymentStatus != transaction.paymentStatus) {
      switch (transaction.paymentStatus) {
        // Processing
        // case 0:
        //   if (window.location.href.includes("offers")) {
        //     break;
        //   }
        case 5:
          showProcessingPaymentModal({ ...transaction });
          break;
        // Success
        case 1:
          showSuccessPaymentModal({
            ...transaction,
            buyMoreUrl: !!eventData.slug ? `/events/${eventData.slug}` : null,
            showConfirmButton: !isOffers
          });

          if (isOffers) {
            this.setState({ submittBlocked: true });
          }
          break;
        // Failed
        case 2:
          showErrorPaymentModal({ ...transaction });
          break;
        // Refunded
        case 4:
          showRefundPaymentModal({ ...transaction });
          break;
        default:
          break;
      }
    }

    this.paymentStatus = transaction.paymentStatus;
  };

  createPathnameWithOrderId = (id) => {
    const pathname = String(this.props.location.pathname);
    const splitedPathname = pathname.split("/");
    const isIncludeId = splitedPathname.length >= 4;
    if (isIncludeId) {
      return `/${splitedPathname[1]}/${splitedPathname[2]}/${id}`;
    }
    return pathname + "/" + id;
  };

  createRedirectURL = (id) => {
    const { isOffers } = this.state;

    if (isOffers) {
      return window.location.href + "?";
    }

    const origin = window.location.origin;
    const pathname = this.createPathnameWithOrderId(id);

    return `${origin}${pathname}?`;
  };

  setTransactionData = (data) => {
    const paymentAmount = data.paymentAmount;

    const orderId = data.orderId || this.state.transactionData.orderId || "";

    const { API_URL } = getCustomURLs();

    const transactionData = {
      ...this.state.transactionData,
      ...data,
      orderId,
      redirectURL: this.createRedirectURL(orderId),
      resURL: `${API_URL}/Payment/Webhook/Kopa`,
    };

    if (paymentAmount) {
      transactionData.paymentAmount = getTotal(
        paymentAmount,
        this.state.feeRate,
        this.state.fixedFeeRate * this.state.tickets.length,
      );
    }

    this.setState({
      transactionData,
    });
  };

  handleSubmit = async () => {
    const txt = getCurrentLanguageTexts();
    try {
      this.showPleaseWaitModal();

      const {
        fields: { paymentMethod, ...otherFields },
        eventData,
        tickets,
        coupon,
      } = this.state;

      await executePayment({
        eventData: eventData,
        paymentMethod: paymentMethod.id,
        paymentType: paymentTypes.online,
        couponCode: coupon ? coupon.barcode : '',
        redirectUrl: this.createRedirectURL('{Id}'),
        tickets: tickets,
        transaction: {
          ...otherFields,
          id: this.props.match.params.transactionId || '',
        }
      });

    } catch (e) {
      console.log(e);
      showErrorModal({
        text: txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
      });
    }
  };

  handleChange = (name, value) => {
    if (name) {
      this.setState({ fields: { ...this.state.fields, [name]: value } });
    }
  };

  handleRepaetEmailChange = debounce((value) => {
    this.setState({ reapetedBuyerEmail: value.trim() });
  }, 700);

  showTermsAndConditionsModal = (ev) => {
    ev.preventDefault();
    MySwal.fire({
      html: <TermsAndConditionsModal />,
      width: "64em",
      customClass: "partizan-info-modal",
    });
  };

  handleChangeCheckbox = (name) => {
    if (name) {
      this.setState({
        checkboxeFields: {
          ...this.state.checkboxeFields,
          [name]: !this.state.checkboxeFields[name],
        },
      });
    }
  };

  checkActionButtonDisabled = () => {
    const {
      step,
      fields: {
        companyName,
        companyVatNumber,
        paymentMethod,
        birthday,
        ...otherFields
      },
      checkboxeFields,
      submittBlocked,
      tickets,
      loading,
      isOffers,
      reapetedBuyerEmail,
    } = this.state;

    if (otherFields.buyerEmail && !isValidEmail(otherFields.buyerEmail))
      return true;

    if (submittBlocked || loading) return true;

    if (isOffers) {
      return (
        !checkboxeFields.termsAndConditionsChecked ||
        !Object.keys(otherFields).every((key) => !!otherFields[key]) ||
        !moment(birthday).isValid()
      );
    };

    switch (step) {
      case 1:
        return !tickets.length;
      case 3:
        return !paymentMethod || reapetedBuyerEmail !== otherFields.buyerEmail;
      case 2:
        return (
          !checkboxeFields.termsAndConditionsChecked ||
          !Object.keys(otherFields).every((key) => !!otherFields[key]) ||
          !moment(birthday).isValid()
        );
      default:
        return false;
    }
  };

  onTicketAdded = (position) => {
    if (isNoSeatTicket(position)) {
      let findedTicket = this.state.tickets.find(
        ({ ticketTemplateId }) => ticketTemplateId === position.ticketTemplateId
      );

      if (findedTicket) {
        this.setState(
          {
            tickets: this.state.tickets.map((ticket) =>
              ticket.ticketTemplateId === position.ticketTemplateId ? position : ticket
            ),
          },
          () => this.setPrice()
        );
        return;
      }
    }
    if (isSeatsIoTicket(position) && !position.pricing) {
      return;
    }
    const tickets = [...this.state.tickets, position];

    this.setState({ tickets }, () => this.setPrice());
  };

  onObjectDeselected = (position) => {
    if ('capacity' in position) {
      this.setState(
        {
          tickets: this.state.tickets.filter(
            (item) => item.ticketTemplateId !== position.ticketTemplateId
          ),
        },
        () => this.setPrice()
      );
    }
    else {
      this.setState(
        {
          tickets: this.state.tickets.filter((item) => item.id !== position.id),
        },
        () => this.setPrice()
      );
    }
  };

  setEventData = (data = {}, shouldfilterUnavailable = true) => {
    document.documentElement.style.setProperty(
      "--partizan-theme",
      this.state.themeColor
    );

    if (!data.isSalesAvailable) {
      this.setState({ submittBlocked: true });
      this.showSalesUnavailableModal();
    }

    if (shouldfilterUnavailable) {
      data.ticketTemplates = filterUnavailableTicketTemplates(
        data.ticketTemplates
      );
    }

    this.setState({
      transactionData: {
        ...this.state.transactionData,
        accessToken: data.paymentToken,
        currencyCode: getCurrencieLabel(data.currencyId),
      },
      hasSeats: data.ticketTemplates.length
        ? data.ticketTemplates.filter(t => t.hasSeats) >= data.ticketTemplates.filter(t => !t.hasSeats)
        : undefined,
      feeRate: data.feeRate || fee,
      fixedFeeRate: data.fixedFeeRate || 0,
      eventData: data,
      fields: {
        ...this.state.fields,
        paymentMethod: {
          id: data.allowedPaymentProviders[0].providerId,
          value: paymentMethodOptions[data.allowedPaymentProviders[0].providerId],
          label: data.allowedPaymentProviders[0].methods[0].name,
        }
      }
    });
  };

  getEventData = async (transactionId) => {
    if (transactionId) {
      const { data } = await axios.get(
        `/EventPublicInfo/ByTransactionId/${transactionId}`
      );

      if (data.code === 4003) {
        throw data
      }

      this.setEventData({ ...data.result }, false);
      return;
    }

    const eventSlug = this.props.match.params.slug;
    const { data } = await axios.get(`/EventPublicInfo/BySlug/${eventSlug}`);

    this.setEventData({
      ...data,
    });
  };

  getOfferTransactionData = async () => {
    if (!this.props.match.params.transactionId) {
      return;
    }

    const transactionId = this.props.match.params.transactionId;

    let tickets = [];

    await this.getEventData(transactionId);

    const { data } = await axios.get(
      `Transaction/TransactionCreationModel/${transactionId}`
    );

    const serializedTransactionModel = JSON.parse(
      data.serializedTransactionCreationModel
    );

    const transactionModel = {};

    for (const key in serializedTransactionModel) {
      if (serializedTransactionModel.hasOwnProperty(key)) {
        transactionModel[key] = serializedTransactionModel[key];
      }
    }

    this.handleOrderStatuses(transactionModel);
    this.setOrderDataToState(transactionModel);

    tickets = serializedTransactionModel.seats.map((seat) => ({
      ticketTemplateId: seat.ticketTemplateId,
      count: 1,
      // name: getSeatTextDescription(seat), ??? why
      name: seat.ticketName,
      ticketName: seat.ticketName,
      amount: seat.amount,
      price: +seat.amount,
      area: seat.area,
      row: seat.row,
      seat: seat.seat,
      side: seat.side,
      fixedDiscount: seat.fixedDiscount,
    }));

    this.setState(
      {
        tickets,
        hasSeats: false,
      },
      () => {
        this.setPrice();
      }
    );
  };

  callAPIs = async () => {
    try {
      this.setState({ loading: true });
      const { id, slug, transactionId } = this.props.match.params;

      switch (true) {
        case !!slug:
          await this.getEventData();
          break;
        case !!transactionId:
          this.setState({ isOffers: true });
          await this.getOfferTransactionData();
          break;
        default:
          throw Error();
      }

      if (id) {
        await this.getTransactionData();
      }

      this.setState({ loading: false });
    } catch (e) {
      this.setState({ loading: false });

      const txt = getCurrentLanguageTexts();

      showErrorModal({
        title: e.errorMessage ? txt.generalTxt["error"] : txt.generalTxt["Something Went Wrong"],
        text: e.errorMessage || txt.sellPageModals["It seems to have failed to complete the payment, please try again"],
        customClass:
          "seasonpass__modal_info seasonpass__modal partizan-info-modal",
        allowOutsideClick: false,
        allowEscapeKey: false,
        showConfirmButton: false,
      });
      console.log(e);
    }
  };

  componentDidMount() {
    this.callAPIs();

    const { transactionId } = this.props.match.params;

    if (!!transactionId) {
      window.addEventListener('beforeunload', (event) => {
        MySwal.close();
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.coupon !== this.state.coupon) {
      this.setPrice();
    }
  }

  render() {
    const {
      step,
      fields,
      coupon,
      checkboxeFields,
      tickets,
      transactionData,
      eventData,
      loading,
      hasSeats,
      feeRate,
      fixedFeeRate,
      isOffers,
      reapetedBuyerEmail,
    } = this.state;
    const txt = getCurrentLanguageTexts();

    this.setCouponHandler = (c) => {
      this.setState({ coupon: c });
      // this.setPrice();
      // this.render();
    };

    this.setCouponHandler = this.setCouponHandler.bind(this);

    if (loading && !isOffers) {
      return <NewLoader isFullScreen />;
    }

    if (!eventData) {
      return null;
    }

    const time = moment(eventData.startDate).format("DD.MM.YYYY HH:mm");

    const pricing = eventData.ticketTemplates.map(({ categoryKey, price }) => ({
      category: categoryKey,
      price,
    }));

    const prefixLabel = eventData.prefixLabel || "";
    const region = getRegion();

    const location = eventData.place || "";

    const { companyVatNumber, companyName, ...otherFields } = fields;
    const requiredFields = Object.keys(otherFields);

    const totalFee = getTotalFee(tickets, fixedFeeRate, feeRate, coupon);

    const offerSteps = [
      {
        title: txt.sellPageTxt["Buy tickets"],
        component:
          <OfferSteps
            tickets={tickets}
            coupon={coupon}
            pricing={pricing}
            totalFee={totalFee}
            loading={loading}
            hasSeats={hasSeats}
            requiredFields={requiredFields}
            fields={fields}
            checkboxeFields={checkboxeFields}
            transactionData={transactionData}
            eventData={eventData}
            handleChange={this.handleChange}
            onObjectSelected={this.onTicketAdded}
            onObjectDeselected={this.onObjectDeselected}
            setCouponHandler={this.setCouponHandler}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
          />,
      },
    ];

    const steps = [
      {
        title: txt.sellPageTxt["Select Tickets"],
        component: (
          <SelectTickets
            totalFee={totalFee}
            tickets={tickets}
            ticketTemplates={eventData.ticketTemplates}
            maxSelectedObjects={eventData.maxSeatsToSelectPerTransaction}
            pricing={pricing}
            hasSeats={hasSeats}
            workspaceKey={eventData.seatsIoWorkspaceId}
            eventSeatsId={eventData.seatsIoEventId}
            event={eventData}
            currency={transactionData.currencyCode}
            onObjectSelected={this.onTicketAdded}
            onObjectDeselected={this.onObjectDeselected}
            total={transactionData.paymentAmount}
            setCouponHandler={this.setCouponHandler}
            coupon={coupon}
          />
        ),
      },
      {
        title: txt.sellPageTxt["Fill in the info"],
        component: (
          <FillFields
            fields={fields}
            requiredFields={requiredFields}
            handleChange={this.handleChange}
            checkboxeFields={checkboxeFields}
            showTermsAndConditionsModal={this.showTermsAndConditionsModal}
            handleChangeCheckbox={this.handleChangeCheckbox}
          />
        ),
      },
      {
        title: txt.sellPageTxt["Buy tickets"],
        component: (
          <ChoosePaymentMethod
            buyerEmail={fields.buyerEmail}
            reapetedBuyerEmail={reapetedBuyerEmail}
            handleRepaetEmailChange={this.handleRepaetEmailChange}
            totalFee={totalFee}
            hasSeats={hasSeats}
            currency={transactionData.currencyCode}
            email={fields.buyerEmail}
            tickets={tickets}
            total={transactionData.paymentAmount}
            paymentMethod={fields.paymentMethod}
            handleChange={this.handleChange}
            setCouponHandler={this.setCouponHandler}
            coupon={coupon}
            allowEnterCouponCode={false}
            paymentMethodOptions={eventData.allowedPaymentProviders.flatMap(p => {
              return p.methods.map(m => {
                return {
                  id: p.providerId,
                  value: paymentMethodOptions[p.providerId],
                  label: m.name,
                }
              })
            })}
          />
        ),
      },
    ];

    const headerComponent = (
      <div>
        <h2 className="partizan-open-selling__stepper-header-event-name">
          {prefixLabel}
        </h2>
        <h2 className="partizan-open-selling__stepper-header-title">
          {eventData.eventName}
        </h2>
        <h5 className="partizan-open-selling__stepper-header-subtitle">
          {txt.sellPageTxt["Supported by"]} {region.title}
        </h5>
        <div className="partizan-open-selling__stepper-header-info">
          <div className="partizan-open-selling__stepper-header-info-location">
            <Icon name={"map-pin-solid"} />
            <p>{location}</p>
          </div>
          <p className="partizan-open-selling__stepper-header-info-time">
            {time}
          </p>
        </div>
      </div>
    );

    const offerActionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div
          style={{ justifyContent: "flex-end" }}
          className="partizan-open-selling__stepper-action-btns"
        >
          <button
            className="btn-primary"
            type="button"
            disabled={this.checkActionButtonDisabled()}
            onClick={this.handleSubmit}
          >
            {txt.sellPageTxt["Pay"]}
          </button>
        </div>
        <div className="seasonpass__bank-logos">
          {bankLogos.map(({ alt, src, link }) => (
            <div key={alt}>
              <a className="partizan-open-selling__bank-link" target="_blank" rel="noopener noreferrer" href={link}>
                <img className="partizan-open-selling__bank-img" /* style={{ height: 30 }} */ src={src} alt={link} />
              </a>
            </div>
          ))}
        </div>
      </div>
    );

    const actionComponent = (
      <div className="partizan-open-selling__stepper-action">
        <div className="partizan-open-selling__stepper-action-btns">
          {step === 1 ? <span></span> : (
            <button
              className="btn-secondary"
              type="button"
              onClick={() => this.handleChangeStep(step - 1)}
            >
              {txt.sellPageTxt["Previous"]}
            </button> 
          )}
          {steps.length === step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={this.handleSubmit}
            >
              {txt.sellPageTxt["Pay"]}
            </button>
          )}
          {steps.length !== step && (
            <button
              className="btn-primary"
              type="button"
              disabled={this.checkActionButtonDisabled()}
              onClick={() => this.handleChangeStep(step + 1)}
            >
              {txt.sellPageTxt["Next"]}
            </button>
          )}
        </div>
        <div className="seasonpass__bank-logos">
          {bankLogos.map(({ alt, src, link }) => (
            <div key={alt}>
              <a className="partizan-open-selling__bank-link" target="_blank" rel="noopener noreferrer" href={link}>
                <img className="partizan-open-selling__bank-img" /* style={{ height: 30 }} */ src={src} alt={link} />
              </a>
            </div>
          ))}
        </div>
      </div>
    );

    return (
      <Container className="seasonpass partizan-open-selling">
        <form className="partizan-open-selling__wrapper">
          <div className="partizan-open-selling__logo seasonpass__header-logo-wrapper">
            <img src={`/${region.theme}/logo.png`} alt="Logo" />
            <h2>{region.title}</h2>
          </div>

          <Stepper
            headerBgStyle={{
              backgroundImage: `url(${eventData.imageUrl})`,
            }}
            headerWrapperClass="partizan-open-selling__stepper-header"
            headerComponent={headerComponent}
            actionComponent={isOffers ? offerActionComponent : actionComponent}
            currentStep={step}
            steps={isOffers ? offerSteps : steps}
          />
        </form>
      </Container>
    );
  }
}

export default withRouter(OpenSell);
